import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const CoursePage = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div className='MainContentFixBottomLine'></div>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_course} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">Course Page</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{verticalAlign: 'middle',display: 'table-cell'}}>
                        <p>The OLE provides two types of course pages: one for full-time courses and the other for distance learning (DL) courses. The course pages for full-time courses are laid out as follows:</p>
                        <div>                        
                            <a href={Image.Word.image004} data-lightbox="CoursePage" >
                                <img border={0} width={600} height={'auto'} src={Image.Word.image004} />
                            </a>
                        </div>
                        
                        <p >Lecturers can upload materials to each week tab of the course and release them to students at the appropriate time.
                            <br/>
                            <a href={Image.Word.image006} data-lightbox="CoursePage" >
                            <img border={0} width={200} height={'auto'}  src={Image.Word.image006} />
                            </a>
                        </p>
                        
                        <div>For DL courses, ALTO is responsible for uploading some of the materials such as study units and assignment files. Unlike full-time courses, DL materials are not organised by week.
                        <br/>
                        <a href={Image.Word.image008} data-lightbox="CoursePage" >
                            <img border={0} width={554} height={'auto'} src={Image.Word.image008} />
                        </a>
                            
                        <br/>
                            
                         
                        <a href={Image.Word.image010} data-lightbox="CoursePage" >
                            <img border={0} width={300} height={'auto'} src={Image.Word.image010} />
                         </a>
                            
                        </div>
                        <p >The table below lists some differences between full-time courses and DL courses.</p>
                        <table className='CoursePageTable'  border={1} cellspacing={0} cellpadding={0} style={{'border-collapse':'collapse','border':'none'}}>
                            <tr >
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >
                                    
                                </b>
                                </p>
                            </td>
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >Full-time courses 
                                </b>
                                </p>
                            </td>
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >Distance learning courses (traditional)</b>
                                <b >
                                    <span  >
                                    
                                    </span>
                                </b>
                                </p>
                            </td>
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >Distance learning courses 
                                </b>
                                </p>
                                <p >
                                <b >(3-credit-unit) 
                                </b>
                                </p>
                            </td>
                            </tr>
                            <tr>
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-top':'none','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >Layout 
                                </b>
                                </p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >By week</p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >By type</p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <a >By week </a>
                                <span >
                                    <span >
                                    
                                    <span >&nbsp;</span>
                                    </span>
                                </span>
                                </p>
                            </td>
                            </tr>
                            <tr >
                            <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-top':'none','mso-border-top-alt':'solid windowtext .5pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >
                                <b >Study units upload 
                                </b>
                                </p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >N/A</p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >Done by ALTO</p>
                            </td>
                            <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt','padding':'0cm 5.4pt 0cm 5.4pt'}}>
                                <p >Done by ALTO</p>
                            </td>
                            </tr>
                        </table>

                        <br/><br/>
                            
                        <span  className='subtitle'>Uploading materials</span>
                            
                        
                        <p >For full-time courses, you can upload materials such as files or hyperlinks to each week by following these steps:</p>
                        <ol>
                            <li>
                                <p>
                                     Click the pencil icon and select ‘Edit items’.
                                
                                    <br/>
                                    <a href={Image.Word.image012} data-lightbox="CoursePage" >
                                    <img border={0} width={500} height={'auto'} src={Image.Word.image012}/>
                                    </a>
                                </p>
                            </li>
                            <li>
                                <p>
                                
                                    <span  > Click the ‘Add files/content’ button. 
                                    </span>
                                    <br/>
                                    <a href={Image.Word.image014} data-lightbox="CoursePage" >
                                    <img border={0} width={500} height={'auto'} src={Image.Word.image014} />
                                    </a>
                                </p>
                            </li>
                            <li>
                                <p>
                                    
                                    <span  > To upload a file, select ‘File’. Enter a title, then choose a file to upload. 
                                        <span >Select the week in which you would like the file to show. </span>
                                    </span>
                                    <br/>
                                    
                                    
                                    <a href={Image.Word.image017} data-lightbox="CoursePage" >
                                    <img border={0} width={500} height={'auto'} src={Image.Word.image017}/>
                                    </a>
                                    
                                </p>
                            </li>
                            <li>
                                <p>
                                    
                                    <span > By default, the file will be visible to all students. However, you can change this by selecting a tutorial group from the ‘Readers’ list. Once you have made your selection, click ‘Save/Upload’. 
                                    </span>
                                    <br/>
                                
                                
                                    <a href={Image.Word.image019} data-lightbox="CoursePage" >
                                    <img border={0} width={500} height={'auto'} src={Image.Word.image019}/>
                                    </a>
                                    
                                </p>
                            </li>
                            <li>
                                <p>
                                     The eye icon controls the visibility of specific items to students.
                                    <br/>
                                    <a href={Image.Word.image021} data-lightbox="CoursePage" >
                                    <img border={0} width={500} height={'auto'} src={Image.Word.image021}/>
                                    </a>
                                    
                                </p>
                            </li>
                        </ol>
                        </div>
                    </div>
                    <NavBtn prevItem='/dashboard' nextItem='/taking-attendance'/>
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default CoursePage;
export default connect(mapStateToProps)(CoursePage);